export function MyFooter () {
    return (
        <footer>
            <p>&copy; 2025 Cindy Hu. All rights reserved.</p>
        </footer>
    )
}